<template>
    <AppNavItem :class="hasChildrenSlot() ? 'nav-item-submenu' : ''">
        <AppNavItemLink :to="{name: to}" ref="link">
            <slot></slot>
        </AppNavItemLink>
        <ul class="nav nav-group-sub" v-if="hasChildrenSlot()">
            <slot name="children"></slot>
        </ul>
    </AppNavItem>
</template>
<script>
import AppNavItem from "../../components/navbar/AppNavItem.vue";
import AppNavItemLink from "../../components/sidebar/AppNavItemLink.vue";

export default {
    name: "AppNavItemGroup",
    components: {
        AppNavItem, AppNavItemLink
    },
    props: {
        to: {
            type: String,
            default: null
        }
    },
    methods: {
        hasChildrenSlot() {
            return !!this.$slots.children
        }
    },
    mounted() {
        let linkElement = this.$refs?.link?.$el

        if (linkElement && linkElement.classList.contains('router-link-active')) {
            linkElement.click();
        }
    }
}
</script>
